import { useState, MouseEvent, useEffect, useRef } from 'react';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { GroupModelInstance } from 'src/store/_models/group';

const DRAG_THRESHOLD = 5;

export function useMultiSelectMouse(computeSelection: () => void, activeGroup?: GroupModelInstance) {
  const { isDesktop } = useResponsiveScreen();
  const startPointRef = useRef<{ x: number; y: number } | null>(null);
  const isDraggingRef = useRef(false);
  const [selection, setSelection] = useState<
    | {
        startX: number;
        startY: number;
        endX: number;
        endY: number;
        isSelecting: boolean;
      }
    | undefined
  >(undefined);

  // const resetSelection = () => {
  //   setSelection(undefined);
  //   activeGroup?.setIsSelecting(false);
  //   isDraggingRef.current = false;
  //   startPointRef.current = null;
  // };

  // useEffect(() => {
  //   if (!isDesktop) return;

  //   const stopSelection = () => {
  //     if (!isDraggingRef.current) {
  //       startPointRef.current = null;
  //       return;
  //     }

  //     resetSelection();
  //   };

  //   window.addEventListener('pointerup', stopSelection);
  //   window.addEventListener('pointercancel', stopSelection);

  //   return () => {
  //     window.removeEventListener('pointerup', stopSelection);
  //     window.removeEventListener('pointercancel', stopSelection);
  //   };
  // }, [isDesktop, selection?.isSelecting]);

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    // if (!isDesktop) return;
    // startPointRef.current = {
    //   x: e.clientX,
    //   y: e.clientY,
    // };
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    // if (!isDesktop || !startPointRef.current) return;
    // const dx = Math.abs(e.clientX - startPointRef.current.x);
    // const dy = Math.abs(e.clientY - startPointRef.current.y);
    // if (!isDraggingRef.current) {
    //   if (dx < DRAG_THRESHOLD && dy < DRAG_THRESHOLD) {
    //     return;
    //   }
    //   isDraggingRef.current = true;
    //   setSelection({
    //     startX: startPointRef.current.x,
    //     startY: startPointRef.current.y,
    //     endX: e.clientX,
    //     endY: e.clientY,
    //     isSelecting: true,
    //   });
    //   activeGroup?.setIsSelecting(true);
    //   return;
    // }
    // setSelection(prev => {
    //   if (!prev) return prev;
    //   return {
    //     ...prev,
    //     endX: e.clientX,
    //     endY: e.clientY,
    //   };
    // });
    // computeSelection();
  };

  return { handleMouseDown, handleMouseMove, selection };
}
